interface FilterPanelProps {
  tags: string[];
  years: number[];
  activeTag: string;
  activeYear: number | "all";
  sort: "date" | "hot";
  resultCount: number;
  onTagChange: (tag: string) => void;
  onYearChange: (year: number | "all") => void;
  onSortChange: (sort: "date" | "hot") => void;
  onReset: () => void;
}

export default function FilterPanel({
  tags,
  years,
  activeTag,
  activeYear,
  sort,
  resultCount,
  onTagChange,
  onYearChange,
  onSortChange,
  onReset,
}: FilterPanelProps) {
  const hasFilter = activeTag !== "all" || activeYear !== "all" || sort !== "date";

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-secondary-600" />
          筛选
        </h3>
        <span className="text-xs text-foreground-400">共 {resultCount} 篇</span>
      </div>

      <div>
        <p className="text-xs font-semibold tracking-widest text-foreground-500 mb-3">标签</p>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onTagChange("all")}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
              activeTag === "all"
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            全部
          </button>
          {tags.map((t) => (
            <button
              key={t}
              onClick={() => onTagChange(t)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
                activeTag === t
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold tracking-widest text-foreground-500 mb-3">发表年份</p>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onYearChange("all")}
            className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors cursor-pointer ${
              activeYear === "all"
                ? "bg-secondary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            不限
          </button>
          {years.map((y) => (
            <button
              key={y}
              onClick={() => onYearChange(y)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors cursor-pointer ${
                activeYear === y
                  ? "bg-secondary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {y} 年
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold tracking-widest text-foreground-500 mb-3">排序方式</p>
        <div className="inline-flex p-1 rounded-full bg-background-100">
          <button
            onClick={() => onSortChange("date")}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
              sort === "date" ? "bg-background-50 text-primary-700 shadow-sm" : "text-foreground-500"
            }`}
          >
            最新发布
          </button>
          <button
            onClick={() => onSortChange("hot")}
            className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
              sort === "hot" ? "bg-background-50 text-primary-700 shadow-sm" : "text-foreground-500"
            }`}
          >
            最热阅读
          </button>
        </div>
      </div>

      {hasFilter && (
        <button
          onClick={onReset}
          className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border border-background-300 text-sm text-foreground-600 hover:border-secondary-400 hover:text-secondary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      )}
    </div>
  );
}